// detectEvents and getSparkline are now computed server-side in
// GET /api/fleet/live — events arrive shaped on each truck snapshot.
// This module keeps only the cheap presentation helpers used across the UI.

export function litersToEur(liters, dieselPrice = 1.14) {
  return (liters * dieselPrice).toFixed(0);
}

export function timeAgo(ts) {
  const s = Math.floor((Date.now() - ts) / 1000);
  if (s < 60) return s + 's ago';
  if (s < 3600) return Math.floor(s/60) + 'm ago';
  if (s < 86400) return Math.floor(s/3600) + 'h ago';
  return Math.floor(s/86400) + 'd ago';
}
